import { AnimatePresence, motion } from "framer-motion";
import style from './Header.module.css';
import { useEffect, useState } from "react";
import { MenuItem, Select } from "@mui/material";
import { MuiTelInput } from "mui-tel-input";

export default function Header({ headerData, selectedHallData, people, hall, setHall }) {
    const totalSteps = 7;
    const [widthSlider, setWidthSlider] = useState(17);
    const [sliderGradient, setSliderGradient] = useState("linear-gradient(90deg, #ff7e00 0%, #c7264a 100%)");

    const variants = {
        enter: {
            y: -20,
            opacity: 0,
        },
        center: {
            y: 0,
            opacity: 1,
        },
        exit: {
            y: 20,
            opacity: 0,
        },
    };

    useEffect(() => {
        headerData.step === 1 ? setWidthSlider(17) : setWidthSlider(Math.round(100 / totalSteps * headerData.step))

        switch (headerData.status) {
            case 0:
                setSliderGradient("linear-gradient(90deg, #ff3333 0%, #b60000 100%)"); break;
            case 1:
                setSliderGradient("linear-gradient(90deg, #f9982e 0%, #b75f00 100%)"); break;
            case 2:
            case 3:
                setSliderGradient("linear-gradient(90deg, #00cd2c 0%, #007f1b 100%)"); break;
        }
    }, [headerData]);

    return (
        <header className={style.container}>
            <div className={style.block_logo}>
                <img src="/assets/img/logo3.png" alt="Лого" />
                <div className={style.logo_text}>Kinoroom Moscow</div>
            </div>

            <div className={style.block}>
                {headerData.step !== 0 && (
                    <div className={style.progress_block}>
                        <div className={style.progress_slider} style={{ width: widthSlider+"%", background: sliderGradient }}></div>
                    </div>
                )}

                <AnimatePresence mode="wait">
                    <motion.h1
                        key={headerData.title}
                        variants={variants}
                        initial="enter"
                        animate="center"
                        exit="exit"
                        transition={{ duration: 0.4 }}
                        className={style.text}
                    >
                        {headerData.title}
                    </motion.h1>
                </AnimatePresence>

                <AnimatePresence mode="wait">
                    <motion.h2
                        key={headerData.text}
                        variants={variants}
                        initial="enter"
                        animate="center"
                        exit="exit"
                        transition={{ duration: 0.4, delay: 0.1 }}
                        className={style.subText}
                    >
                        {headerData.text}
                    </motion.h2>
                </AnimatePresence>

                {headerData.step === 4 && (
                    <AnimatePresence mode="wait">
                        <motion.h2
                            key={selectedHallData}
                            variants={variants}
                            initial="enter"
                            animate="center"
                            exit="exit"
                            transition={{ duration: 0.4, delay: 0.1 }}
                            className={style.subText}
                        >
                            <Select
                                size="small"
                                value={hall}
                                onChange={(e) => setHall(e.target.value)}
                            >
                                {Object.keys(JSON.parse(selectedHallData?.HallsData)).map((hallMap) => {
                                    const hallData = JSON.parse(selectedHallData?.HallsData)[hallMap];
                                    if (hallData.maxPeople >= people) {
                                        return (
                                            <MenuItem value={Number(hallMap)}>{selectedHallData.AddressFull}, зал №{hallMap}</MenuItem>
                                        )
                                    }
                                })}
                            </Select>
                        </motion.h2>
                    </AnimatePresence>
                )}
            </div>
        </header>
    );
}
